enum DistributorCategory {
  FinancialService = 'Financial Services',
  RealEstate = 'Real Estate',
  Other = 'Other',
}

export default DistributorCategory;
